import img from '../../../../../assets/images/textEditorToolBarIcons/Ordered.svg';

export const OrderedButton = img;
